import React, { Component } from 'react';
import { Redirect, Route } from 'react-router';
import { Layout } from './components/Layout/Layout';
import { ProposalForm } from './components/Proposal/Proposal';
import { WelcomePage } from './components/Welcome/Welcome';
import { LoginComponent } from './components/LoginComponent/LoginComponent';
import { ConfirmPage } from './components/LoginComponent/ConfirmPage';
import { ResetPWPage } from './components/LoginComponent/ResetPWPage';
import { ExternalConsent } from './components/LoginComponent/ExternalConsent';
import { PrivateRoute } from './components/PrivateRoute';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { Common } from './components/LoginComponent/Common';

import './custom.scss'
import DataProvider from './dataprovider/DataProvider';
import ProposalStore from './components/Proposal/ProposalStore';
import { CookieList } from './components/LoginComponent/CookieList';

import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = "653718434571-o0evjrj6esk9ekfh1k3ndihvuttfn1pk.apps.googleusercontent.com";

export const PageURL = {
    CreateProposal: "/proposal",
    ConfirmationPage: "/confirm",
    ResetPWPage: "/resetPW",
    Consent: "/consent",
    CookieList: "/cookies"
}

// const msalConfig = {
//     auth: {
//         clientId: "1809a5ba-5ed7-4764-ac1b-d78b2c878ee4",
//         authority: "https://login.microsoftonline.com/1900aa23-cb5a-4a45-8ad0-968d229e955f",
//         redirectUri: "https://localhost:44350/",
//     },
//     cache: {
//         cacheLocation: "sessionStorage", // This configures where your cache will be stored
//         storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
//     }
// };

function getMSALConfig(){
    let returnURI = Common.getCurrentServerUrl();
    //console.log(`%cMSAL ReturnURI: ${returnURI}`, "color:green;font-size:14px");
    return  {
        auth: {
            clientId: "b1701714-7360-4883-94c9-423bd89071cc",
            authority: "https://login.microsoftonline.com/common",
            redirectUri: `${returnURI}`
        },
        cache: {
            cacheLocation: "sessionStorage", // This configures where your cache will be stored
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        }
    };
}

const msalInstance = new PublicClientApplication(getMSALConfig());


export default class App extends Component {
    refLoginComponent = null;

    constructor() {
        super();
        this.state = {
            isLoggedIn: false,
            currentUser: null,
            path: "/",
            redirectHome: false
        };

        this.refLoginComponent = React.createRef();
    }    

    componentDidMount() {
        // in case the page is reloaded, check if there is a user in the session already
        if (window.sessionStorage.authToken) {
            let authToken = JSON.parse(window.sessionStorage.authToken);
            let expirationDate = new Date(authToken.expirationUTC);
            if (expirationDate < new Date()) {
                // this token is expired. Clean it up
                window.sessionStorage.removeItem("authToken");
                window.sessionStorage.removeItem("rsmUser");
                alert("Your Session expired. Please sign-in again.");
            }
            if (window.sessionStorage.rsmUser) {
                let currentUser = JSON.parse(window.sessionStorage.rsmUser);
                this.setState({
                    isLoggedIn: true,
                    currentUser: currentUser
                });
            }
        }
    }

    setAuthStatus = (loggedIn, user) => {

        return new Promise((resolve, reject) => { 
            this.setState({ isLoggedIn: loggedIn, currentUser: user }, () => {
                console.log("%cLOG OUT HERE!!!!!", "color:yellow;font-size:16px");

                if (!user) {
                    sessionStorage.removeItem("authToken");
                    sessionStorage.removeItem("rsmUser");

                    //this.setState({redirectHome: true});
                    // redirect to home
                    console.log("New Url: "+`${window.location.protocol}//${window.location.host}`);
                    window.location.href = `${window.location.protocol}//${window.location.host}`;

                }

                resolve();
            });
            console.log("%cCurrent User", "color:blue;font-size:16px", user);
        });
    }

    sessionExpired = () => {
        this.setState({
            isLoggedIn: false,
            currentUser: null
        });
        window.sessionStorage.removeItem("authToken");
        window.sessionStorage.removeItem("rsmUser");
        alert("Your Session expired. Please sign-in again.");
    };

    static displayName = App.name;

    dataProvider = new DataProvider();
    proposalStore = new ProposalStore();


    render() {
        return (            
            <Layout>
                {this.state.redirectHome && <Redirect to="/" />}
                <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                    <MsalProvider instance={msalInstance}>
                        <Route exact path='/' render={(props) => {
                            if(this.state.path !== "/")
                                this.setState({ path: "/" });
                            return <WelcomePage {...props} dataProvider={this.dataProvider} currentUser={this.state?.currentUser} isLoggedIn={this.state.isLoggedIn} />;
                        }} />
                        <Route exact
                            path={PageURL.ConfirmationPage}
                            render={(props) => {
                                if (this.state.path !== PageURL.ConfirmationPage)
                                    this.setState({ path: PageURL.ConfirmationPage });
                                return <ConfirmPage {...props} dataProvider={this.dataProvider} />;
                            }}
                        />
                        <Route exact
                            path={PageURL.ResetPWPage}
                            render={(props) => {
                                if (this.state.path !== PageURL.ResetPWPage)
                                    this.setState({ path: PageURL.ResetPWPage });
                                return <ResetPWPage {...props} dataProvider={this.dataProvider} />;
                            }}
                        />
                        <Route exact
                            path={PageURL.CreateProposal}                    
                            render={(props) => (
                                <>
                                {
                                        this.state.isLoggedIn && <ProposalForm sessionExpired={this.sessionExpired } currentUser={this.state?.currentUser} {...props} isLoggedIn={this.state.isLoggedIn} dataProvider={this.dataProvider} proposalStore={this.proposalStore} />
                                }                        
                                </>
                            )}
                            />
                        <Route exact
                            path={PageURL.Consent}
                            render={(props) => {
                                if (this.state.path !== PageURL.Consent)
                                    this.setState({ path: PageURL.Consent });
                                return <ExternalConsent setAuthStatus={this.setAuthStatus} loginComponent={this.refLoginComponent.current} {...props} />;
                            }
                            }/>
                        <Route exact 
                            path={PageURL.CookieList} 
                            render={(props)=>{
                                return <CookieList {...props} />;
                            }}
                            />
                        <div style={{ height: '100%' }}><LoginComponent key={this.state.path} ref={ this.refLoginComponent } setAuthStatus={this.setAuthStatus} currentUser={this.state?.currentUser} /></div>
                    </MsalProvider>
                </GoogleOAuthProvider>
            </Layout>            
        );
    }
}
